import { call, cancelled, put, select } from 'redux-saga/effects';

import * as AppActions from '../../../actions';
import * as AppConstants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import { branch, pipe } from '../../../sagas/Helpers';
import * as AppUtils from '../../../utils';

import * as PlayResumeHelpers from './helpers';

function hydrateAction(state, action) {
  action.data.isInitialLoad = !getInDomain(
    'playback.utils.hasPlaybackStartedInSession',
    false,
  )(state);

  if (!action.data.playSourceUsingPandoraId) {
    action.data.pandoraId =
      action.data.pandoraId || AppUtils.Music.isOnDemandIdLike(action.data.id)
        ? action.data.id
        : getInDomain('playback.utils.getStationPandoraId')(state, action.data.id);
  }

  action.data.pandoraType =
    action.data.pandoraType ||
    AppUtils.SourceType.getPandoraTypeFromPandoraId(action.data.pandoraId);
}

function* shouldInterceptPlayback(action) {
  const { pandoraId, pandoraType, pageUrl } = action.data;
  const isMobileWeb = yield select(AppUtils.Capabilities.isMobileWeb);

  if (isMobileWeb) {
    window.location = yield select(AppUtils.Route.getMobileLongLink, {
      pageUrl,
      feature: AppConstants.Urls.deepLinkParams.BACKSTAGE_PAGE,
    });
    return true;
  }

  const annotations = yield select(AppUtils.Entity.getAnnotationsById, pandoraId);

  if (
    pandoraType === AppConstants.SourceTypes.PandoraTypes.PODCAST &&
    AppUtils.Rights.isRetired(annotations)
  ) {
    yield put(
      AppActions.Modal.openModalCoachmark(AppConstants.Collection.messages.podcastUnavailable),
    );
    return true;
  }

  return false;
}

export function* playResumeSource(action) {
  yield select(hydrateAction, action);

  if (yield call(shouldInterceptPlayback, action)) {
    return;
  }

  try {
    yield call(
      pipe([
        branch(
          PlayResumeHelpers.isResuming,
          branch(
            PlayResumeHelpers.shouldSetInteractiveRadioModeOnPlay,
            PlayResumeHelpers.resumeWithNewMode,
            PlayResumeHelpers.resumePlayback,
          ),
          branch(
            PlayResumeHelpers.shouldUseAPS,
            pipe([
              PlayResumeHelpers.startingSource,
              PlayResumeHelpers.verifySourceRights,
              PlayResumeHelpers.logTTM,
              PlayResumeHelpers.startSource,
              PlayResumeHelpers.setShuffleMode,
              PlayResumeHelpers.sourceStarted,
            ]),
            PlayResumeHelpers.startStation, // legacy station playback
          ),
        ),
        PlayResumeHelpers.reRoute,
      ]),
      action,
    );
  } finally {
    if (yield cancelled()) {
      yield put(
        AppActions.Integrations.startSourceIncomplete({
          sourceId: action.data.id,
        }),
      );
    }
  }
}
